import { useState, useEffect } from 'react';

export function CheckoutSection() {
  const [minutes, setMinutes] = useState(59);
  const [seconds, setSeconds] = useState(36);

  useEffect(() => {
    const timer = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      } else if (minutes > 0) {
        setMinutes(minutes - 1);
        setSeconds(59);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [minutes, seconds]);

  return (
    <section
      id="checkout"
      className="relative py-16 sm:py-24 lg:py-32 overflow-hidden bg-gradient-to-br from-emerald-50 via-cyan-50 to-teal-50"
    >
      <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-emerald-300/30 to-cyan-300/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-br from-teal-300/30 to-emerald-300/30 rounded-full blur-3xl"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-br from-cyan-200/20 to-emerald-200/20 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-2xl mx-auto mb-8 sm:mb-12">
          <div className="bg-gradient-to-r from-red-500 via-orange-500 to-red-500 rounded-2xl p-6 sm:p-8 shadow-2xl border-4 border-white animate-pulse">
            <div className="text-center space-y-4">
              <div className="flex items-center justify-center gap-2 mb-2">
                <i className="ri-alarm-warning-line text-white text-2xl sm:text-3xl"></i>
                <h3 className="text-xl sm:text-2xl font-extrabold text-white">⚡ OFERTA EXPIRA EN:</h3>
                <i className="ri-alarm-warning-line text-white text-2xl sm:text-3xl"></i>
              </div>
              <div className="flex justify-center gap-3 sm:gap-4">
                <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 sm:p-6 min-w-[90px] sm:min-w-[120px] border-2 border-white/30">
                  <div className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-2">
                    {minutes.toString().padStart(2, '0')}
                  </div>
                  <div className="text-white text-xs sm:text-sm font-bold uppercase tracking-wider">
                    Minutos
                  </div>
                </div>
                <div className="flex items-center">
                  <span className="text-4xl sm:text-5xl font-bold text-white">:</span>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 sm:p-6 min-w-[90px] sm:min-w-[120px] border-2 border-white/30">
                  <div className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-2">
                    {seconds.toString().padStart(2, '0')}
                  </div>
                  <div className="text-white text-xs sm:text-sm font-bold uppercase tracking-wider">
                    Segundos
                  </div>
                </div>
              </div>
              <div className="space-y-2 pt-2">
                <p className="text-white font-bold text-base sm:text-lg">
                  🔥 Solo quedan 7 cupos disponibles a este precio
                </p>
                <p className="text-white/90 text-sm sm:text-base">
                  ⚠️ Después de esto, S/150 volverá a S/47
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4 sm:mb-6">
            Comienza tu transformación{' '}
            <span className="bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">
              hoy mismo
            </span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 leading-relaxed">
            Acceso completo a todos los cursos, comunidad y actualizaciones
          </p>
        </div>

        <div className="flex justify-center max-w-2xl mx-auto">
          <div className="relative rounded-3xl p-8 sm:p-10 cursor-pointer transition-all duration-300 bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-600 shadow-2xl hover:shadow-emerald-500/50 hover:scale-105 w-full">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-yellow-400 to-orange-400 text-gray-900 px-6 py-2 rounded-full text-sm font-bold whitespace-nowrap shadow-lg animate-pulse">
              🔥 MÁS POPULAR
            </div>

            <div className="text-center space-y-6">
              <div>
                <h3 className="text-2xl sm:text-3xl font-bold mb-2 text-white">Acceso de Por Vida</h3>
                <p className="text-sm sm:text-base text-emerald-100">Pago único • Sin renovaciones</p>
              </div>

              <div className="py-6">
                <div className="flex items-center justify-center gap-3 mb-2">
                  <span className="text-3xl sm:text-4xl font-bold text-white/60 line-through">S/150</span>
                  <span className="text-5xl sm:text-6xl lg:text-7xl font-extrabold text-white">S/70</span>
                </div>
                <p className="text-emerald-100 text-sm sm:text-base">Pago único • Acceso ilimitado</p>
              </div>

              <ul className="space-y-4 text-left">
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-white text-base sm:text-lg">Acceso a todos los cursos</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-white text-base sm:text-lg">Actualizaciones de por vida</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-white text-base sm:text-lg">Comunidad privada en Skool</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-white text-base sm:text-lg">Clases en vivo mensuales</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-white text-base sm:text-lg">Soporte 24/7</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-white text-base sm:text-lg">Soporte de vida</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
